import { useEffect, useState } from "react";
import { Container } from "./styles";
import { IconAccept, IconWrong, IconInProgress, IconArrowUp, IconArrowDown } from "../../icons";
import { comum } from "../../../styles/Themes/light";
import { Oval } from "react-loader-spinner";
import toast, { Toaster } from 'react-hot-toast';
import api from "../../../services/api";
import toastservice from "../../../services/toast";

export default function ContadorPendencias({
    id_proposta,
    setPendenciaAberta,
    pendenciaAberta,
    solicitante=false
}: {
    id_proposta: any;
    setPendenciaAberta: (pendenciaAberta: boolean) => void;
    pendenciaAberta: boolean;
    solicitante?: boolean;
}) {
    const [ contadorPendencias, setContadorPendencias ] = useState<any>();
    const [ loading, setLoading] = useState<any>(false);


    async function carregaContadores() {
        try {
            setLoading(true);

            const response = await api.get(`pendencia-contadores/` + id_proposta);
            setContadorPendencias(response.data.result);
            
            if (response.data.status !== 'success') {
                if (response.data.message === '1 Erros encontrados') {
                    throw new Error(response.data.result[0].message);
                } else {
                    throw new Error(response.data.message);
                }
            }
            setLoading(false);

        } catch (error: any) {
            toastservice.error(error.message);
            setLoading(false);
        }
        
    }

    useEffect(() => {
        if(id_proposta !== '') {
            carregaContadores();
        }
    }, [id_proposta]);

    return (
        <Container>
            {
                loading &&
                <Oval
                    height={150}
                    width={150}
                    color={comum.colors.primaryRed400}
                    wrapperStyle={{}}
                    wrapperClass="loader"
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor={comum.colors.primaryRed400}
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                />
            }
                <div className="card resolved">
                    <div className="top">{contadorPendencias?.resolvidas ? contadorPendencias.resolvidas : 0} <IconAccept /></div>
                    <span>Resolvidas</span>
                </div>
                {
                    !solicitante &&
                <div className="card accept">
                    <div className="top">{contadorPendencias?.aceitas ? contadorPendencias.aceitas : 0} <IconAccept /></div>
                    <span>Aceitas</span>
                </div>
                }
                {
                    !solicitante &&
                <div className="card refused">
                    <div className="top">{contadorPendencias?.recusadas ? contadorPendencias.recusadas : 0} <IconWrong /></div>
                    <span>Recusadas</span>
                </div>
                }
                <div className="card waiting">
                    <div className="top">{contadorPendencias?.aguardando ? contadorPendencias.aguardando : 0} <IconInProgress /></div>
                    <span>Aguardando</span>
                </div>
                <div className="card response">
                    <div className="top">{contadorPendencias?.responder ? contadorPendencias.responder : 0}</div>
                    <span>Responder</span>
                </div>
                <div 
                    className="arrow"
                    onClick={() => setPendenciaAberta(!pendenciaAberta)}
                >   
                    {
                        pendenciaAberta
                        ?   <IconArrowUp />
                        :   <IconArrowDown />
                    }
                    
                </div>
        </Container>
    )
}